/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const CheckSquareOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.12 9.75 10.62 15l-2.74-2.62M4.5 3.75h15c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75z"
})));
// Fill
const CheckSquareFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.5 3h-15A1.499 1.499 0 0 0 3 4.5v15A1.499 1.499 0 0 0 4.5 21h15a1.499 1.499 0 0 0 1.5-1.5v-15A1.499 1.499 0 0 0 19.5 3zm-2.86 7.29-5.49 5.25c-.15.14-.33.21-.53.21-.19 0-.38-.07-.51-.21l-2.75-2.62a.69.69 0 0 1-.18-.24.74.74 0 0 1-.08-.29c0-.1.01-.2.05-.3.03-.09.09-.18.16-.25a.66.66 0 0 1 .24-.17c.1-.04.2-.07.3-.07s.2.02.29.06c.1.04.18.1.25.17l2.23 2.13 4.99-4.75a.739.739 0 0 1 1.04.05c.13.14.2.32.2.52 0 .19-.07.37-.21.51z"
})));
// DuoTone
const CheckSquareDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.5 3.75h-15c-.41 0-.75.34-.75.75v15c0 .41.34.75.75.75h15c.41 0 .75-.34.75-.75v-15c0-.41-.34-.75-.75-.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.12 9.75 10.62 15l-2.74-2.62M4.5 3.75h15c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75z"
})));
/**
  Icon CheckSquareIcon in system group
*/
export const CheckSquareIcon = createIcon('CheckSquareIcon', 'check-square', 'system', CheckSquareOutline, CheckSquareFill, CheckSquareDuotone, "0 0 24 24");